export * from "./languages";

export const AI_POST_BASE_URL = "https://ai-post.blogix.uz";
export const GENERATE_POST_ENDPOINT = "/post/generate-ai";
